import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../../index';

type RolesState = string[];

const initialState: RolesState = [];

const rolesSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {
    setRoles: (_state, action: PayloadAction<string[]>) => action.payload,
  },
});

export const { setRoles } = rolesSlice.actions;
export default rolesSlice.reducer;

export const selectRoles = (state: RootState): RolesState => state.roles;
